export default __webpack_public_path__ + "static/media/honda.dae9743e.svg";